import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from '../../../components/widgets/Select';
import { ACTION_OPTIONS, ACTION_OPTIONS_NO_REJECT, ACTION_VALUES } from '../constants';
import selectCss from '../../../components/widgets/ReactSelectOverrides.css';
import css from '../style.css';

const optionStyles = {
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? 'var(--blue50)' : state.isFocused ? 'var(--blue100)' : 'var(--white)',
        color: 'var(--gray700, #334155)',
        borderBottom: '1px solid var(--gray200)',
        cursor: 'pointer',
        ':active': { backgroundColor: 'var(--blue100)' },
    }),
};

const SettingCard = ({ setting, value, warning, onChange, translate, extra }) => {
    const options = (setting.noReject ? ACTION_OPTIONS_NO_REJECT : ACTION_OPTIONS).map(option => ({
        value: option.value,
        label: translate(option.label),
    }));
    const selectedOption = options.find(option => option.value === value) || null;

    return (
        <div className={css.settingCard}>
            <div className={css.cardTop}>
                <span className={classNames(css.statusDot, { [css.disabled]: value === ACTION_VALUES.DO_NOTHING })}>
                    •
                </span>
                <span className={css.settingName}>{translate(setting.nameKey)}</span>
                <div className={css.actionDropdown}>
                    <Select
                        classNamePrefix="Select"
                        className={classNames(selectCss.singularSelect, { [selectCss.error]: warning })}
                        styles={optionStyles}
                        options={options}
                        value={selectedOption}
                        isSearchable={false}
                        isClearable={false}
                        usePortal
                        onChange={option => onChange(setting.id, option.value)}
                    />
                </div>
            </div>
            <div className={css.cardBody}>
                <div>{translate(setting.descriptionKey, null, { renderInnerHtml: true })}</div>
                {setting.exampleKeys.map(exampleKey => (
                    <div key={exampleKey} className={css.example}>
                        {translate(exampleKey, null, { renderInnerHtml: true })}
                    </div>
                ))}
                {extra}
            </div>
        </div>
    );
};

SettingCard.propTypes = {
    setting: PropTypes.shape({
        id: PropTypes.string.isRequired,
        nameKey: PropTypes.string.isRequired,
        descriptionKey: PropTypes.string.isRequired,
        exampleKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
        noReject: PropTypes.bool,
    }).isRequired,
    value: PropTypes.number.isRequired,
    warning: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    extra: PropTypes.node,
};

export default SettingCard;
